import { combineReducers } from 'redux';
import localStorage from 'redux-persist/lib/storage';
import homeReducer from '../../modules/home/slice/homeSlice';
import wipReducer from '../../modules/investments-wip/slice/wipSlice';
import loginReducer from '../../modules/login/slice/loginSlice';
import fundReducer from '../../modules/fund/Slice/FundSlice';
import notification from 'modules/home/slice/notification';
import fundDataReducer from 'modules/fund/Slice/FundDataSlice';
import scoringMatrixReducer from 'modules/fund/Slice/ScoringMatrixSlice';
import portfolioReducer from 'modules/PacingPlan/slice/pacingPlanSlice';
import landingPageReducer from 'modules/landingPage/slice/landingPageSlice';
import fundManagerReducer from 'modules/fundManager/slice/fundManagerSlice';
import companyEntitiesReducer from 'modules/companyEntities/slice/companyEntitiesSlice';
import fundDocumentReducer from 'modules/fundDocument/slice/fundDocumentSlice';
import investmentReducer from 'modules/investments/slice/investmentSlice';
import contactsReducer from 'modules/contactPage/slice/contactsSlice';
import contactReducer from 'modules/fund/Slice/contactSlice';
import fundManagerDetailReducer from 'modules/fund/Slice/fundManagerDetailSlice';
import companyAssetsDetailsReducer from 'modules/fund/Slice/companyAssetsSlice';
import aiChatReducer from 'modules/aiChat/store/aiChatSlice';
import ladingTopStateReducer from 'modules/fund/Slice/LandingPageSlice';
import portfolioCompanySlice from 'modules/fund/Slice/portfolioCompaniesSlice';
import portfolioTeamsSlice from 'modules/fund/Slice/portfolioTeamsSlice';
import errorBoundarySlice from 'error-boundary/Slice/errorSlice';
import { api } from 'services/api/baseBackendAPI';

const appReducer = combineReducers({
  wip: wipReducer,
  home: homeReducer,
  login: loginReducer,
  fundDetails: fundReducer,
  fundData: fundDataReducer,
  notification: notification,
  scoringMatrix: scoringMatrixReducer,
  portfolio: portfolioReducer,
  landingPage: landingPageReducer,
  fundManagerPage: fundManagerReducer,
  companyEntitiesPage: companyEntitiesReducer,
  fundDocumentPage: fundDocumentReducer,
  investmentPage: investmentReducer,
  contactsPage: contactsReducer,
  contact: contactReducer,
  fundManagerDetail: fundManagerDetailReducer,
  companyAssetsDetail: companyAssetsDetailsReducer,
  ladingPage: ladingTopStateReducer,
  portfolioCompanyDetails: portfolioCompanySlice,
  portfolioTeams: portfolioTeamsSlice,
  error: errorBoundarySlice,
  aiChat: aiChatReducer,
  [api.reducerPath]: api.reducer,
});

export const rootReducer = (state, action) => {
  if (action.type === 'login/logout') {
    // this applies to all keys defined in persistConfig(s)
    localStorage.removeItem('persist:root');
    state = {};
    window.location?.reload();
  }
  return appReducer(state, action);
};
